import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { renderWhenTrueOtherwise } from '../../../../utils/rendering';
import { ariaLiveHandler } from '../../../../utils/accessibility';
import { Container, Bars, Bar, Cross, CrossElement } from './hamburgerMenu.styles';

export class HamburgerMenu extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    isMenuOpened: PropTypes.bool,
  };

  render() {
    return (
      <Container
        onClick={this.props.onClick}
        aria-expanded={this.props.isMenuOpened}
        aria-label="menu"
        aria-live={ariaLiveHandler()}
      >
        {
          renderWhenTrueOtherwise(
            () => (
              <Bars>
                <Bar />
                <Bar />
                <Bar />
              </Bars>
            ),
            () => (
              <Cross>
                <CrossElement reverse />
                <CrossElement />
              </Cross>
            )
          )(!this.props.isMenuOpened)
        }
      </Container>
    );
  }
}
